<script>
import swal from "sweetalert";
import {slownikiService} from "@/services/slowniki.service";

export default {
  name: "WyborLeku",
  data() {
    return {
      full_search_items: [],
      full_search_loading: false,
      full_search_selected: null,
      lekKeyword: '',
      wybrane_opakowanie: null,
      dostepne_opakowania: [],
    }
  },
  methods: {
    showError(text) {
      swal({
        title: "Błąd",
        text: text,
        icon: "warning",
        button: "OK"
      }).then(() => {

          }
      )
    },
    getLeki()
    {
      slownikiService.GetProduktyLecznicze(this.lekKeyword).then(resp => {
        this.full_search_items = resp.data.result;
        this.full_search_loading = false;
      }).catch(() => {
        this.full_search_loading = false;
        this.showError("Błąd pobierania leków")
      });
    },
    wybranoLek()
    {
      if(this.full_search_selected)
      {
        let opakowania = this.full_search_selected.opakowania.filter(x=>x.czy_skasowane == false)

        this.dostepne_opakowania = opakowania
        if(opakowania.length == 1) {
          this.wybrane_opakowanie = opakowania[0]
          this.$emit('wybranoLek',{lek: this.full_search_selected, opakowanie: this.wybrane_opakowanie})
        }
      }
      else
      {
        this.dostepne_opakowania = []
        this.wybrane_opakowanie = null
        this.$emit('wybranoLek',null)
      }
    },
    wybranoOpakowanie()
    {
      this.$emit('wybranoLek',{lek: this.full_search_selected, opakowanie: this.wybrane_opakowanie})
    }
  },
  watch: {
    lekKeyword: function (newVal, oldVal) {
      if(newVal && newVal.length > 2) {
        this.full_search_loading = true;
        this.getLeki();
      }
    }
  }
}
</script>

<template>
  <v-row>
    <v-col cols="12" sm="12" md="6" lg="6">
        <v-autocomplete :items="full_search_items" :loading="full_search_loading" return-object
                    label="Nazwa leku" v-model="full_search_selected"
                    hide-details no-data-text="Nie znaleziono" item-text="nazwa_moc"
                    :search-input.sync="lekKeyword" clearable @change="wybranoLek"></v-autocomplete>
    </v-col>
    <v-col cols="12" sm="12" md="6" lg="6">
      <v-select :items="dostepne_opakowania" :disabled="dostepne_opakowania == null || dostepne_opakowania.length == 0" label="Opakowanie" item-text="opis_opakowania"
                return-object v-model="wybrane_opakowanie" @change="wybranoOpakowanie"></v-select>
    </v-col>
  </v-row>
</template>

<style scoped>

</style>